'use client'

import EnterViewAnimate from '@/components/enterView/animate'
import Button from '@/components/form/button'
import { toSlug } from '@/lib/url'
import IconNext from '@icon/variable/next.svg'
import ImgMap from '@image/about/map.png'
import { cn } from '@utils'
import { map } from 'lodash-es'
import 'swiper/css'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import data from './data.json'

export default function History() {
  return (
    <section
      id={toSlug('History')}
      className='py-12.5 pl-4 lg:py-25 bg-bg-primary bg-contain bg-no-repeat bg-center section:pl-[calc((100vw-min(100vw,var(--breakpoint-section)))/2)]'
      style={{ backgroundImage: `url(${ImgMap.src})` }}
    >
      <EnterViewAnimate animate='animate__fadeInRight'>
        <Swiper
          modules={[Navigation]}
          slidesPerView={1}
          spaceBetween={40}
          slidesOffsetAfter={-120}
          grabCursor
          navigation={{ prevEl: '#history-prev', nextEl: '#history-next' }}
          breakpoints={{
            1024: { spaceBetween: 28, slidesPerView: 3 },
            768: { slidesPerView: 2 },
          }}
          className='!pr-30'
        >
          {map(data, (item, idx) => (
            <SwiperSlide key={idx}>
              <div className='text-3xl font-bold'>{item.year}</div>
              <div className='border-t border-secondary/50 border-dashed mt-6.5 mb-10 relative ml-12.5'>
                <i className='w-7.5 h-7.5 rounded-full bg-secondary/50 absolute -left-12.5 top-1/2 -translate-y-1/2 grid place-items-center'>
                  <IconNext className='fill-white' />
                </i>
              </div>
              <div dangerouslySetInnerHTML={{ __html: item.text }}></div>
            </SwiperSlide>
          ))}
        </Swiper>
      </EnterViewAnimate>
      <div className='hidden lg:block mt-5'>
        <EnterViewAnimate
          animate='animate__fadeInUp'
          className='flex gap-x-10 justify-center'
        >
          <NavigationButton id='history-prev' left />
          <NavigationButton id='history-next' />
        </EnterViewAnimate>
      </div>
    </section>
  )
}

function NavigationButton({ id, left }: { id: string; left?: boolean }) {
  return (
    <Button
      id={id}
      className='w-15 h-14 rounded-sm disabled:bg-[#E6E6E6] disabled:cursor-auto'
    >
      <IconNext className={cn('fill-white', { 'rotate-180': left })} />
    </Button>
  )
}
